// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#product-description ul{list-style-position:inside;list-style-type:disc}#product-description ul li{line-height:1.5rem}#product-description h3:nth-of-type(2){border-top:1px solid #000;border-bottom:1px solid #000}#product-description h3:nth-of-type(3){border-bottom:1px solid #000}#product-description ul.list-product-care,#product-description ul.list-product-details{list-style:disc;list-style-position:inside}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
